<div atxDropdown [atxDropdownMenu]="menu">
  <epc-dynamic-collections-renderer
    [items]="dynamicTriggerContentItems"
    [parent]="this"
    [scope]="scope"
    class="d-contents"
  >
  </epc-dynamic-collections-renderer>
</div>

<atx-dropdown-menu
  #menu="atxDropdownMenu"
  [extraClasses]="['promotion-dropdown']"
>
  <epc-dynamic-collections-renderer
    [items]="dynamicDropdownContentItems"
    [parent]="this"
    [scope]="scope"
    class="d-contents"
  >
  </epc-dynamic-collections-renderer>
</atx-dropdown-menu>
